@if (isOpen) {
<div class="modal-overlay">
  <div class="modal-dialog" [class.modal-dialog--wide]="currentStep === 2" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="modal-header">
      <h2 class="modal-title">{{ currentStep === 2 ? 'Step 2: Add Action Plan' : (_editMode ? 'Step 1: Edit Issue' : 'Step 1: Add Issue') }}</h2>
      <button type="button" class="modal-close" (click)="close()" aria-label="Close">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke-width="2.2">
          <circle cx="12" cy="12" r="10" fill="#1a1a1a" stroke="#1a1a1a" />
          <line x1="8" y1="8" x2="16" y2="16" stroke="#ffffff" stroke-linecap="round" />
          <line x1="16" y1="8" x2="8" y2="16" stroke="#ffffff" stroke-linecap="round" />
        </svg>
      </button>
    </div>

    @if (currentStep === 1) {
    <!-- Step 1 Body -->
    <div class="modal-body">
      <div class="form-grid">

        <!-- ───────── Left column ───────── -->
        <div class="form-col">
          <div class="form-field">
            <label class="field-label">Issue ID</label>
            <input type="text" class="field-input field-input--readonly" [value]="form.issueId" readonly />
          </div>

          <div class="form-field" data-field="issueTitle">
            <label class="field-label">Issue Title <span class="required">*</span></label>
            <input type="text" class="field-input" [(ngModel)]="form.issueTitle" placeholder="Enter Issue Title" (ngModelChange)="validateField('issueTitle')" />
            @if (formErrors['issueTitle']) { <span class="field-error">{{ formErrors['issueTitle'] }}</span> }
          </div>

          <div class="form-field" data-field="issueDescription">
            <label class="field-label"> Issue Description <span class="required">*</span></label>
            <textarea class="field-textarea" rows="4"
              placeholder="Enter Issue Description"
              [(ngModel)]="form.issueDescription" (ngModelChange)="validateField('issueDescription')"></textarea>
            @if (formErrors['issueDescription']) { <span class="field-error">{{ formErrors['issueDescription'] }}</span> }
          </div>

          <div class="form-field">
            <label class="field-label">R&amp;C Reviewer</label>
            <div class="chips-input field-input--readonly">
              @if (form.rcReviewer) { <span class="chip chip--readonly">{{ form.rcReviewer }}</span> }
              @if (secondaryRcReviewer) { <span class="chip chip--readonly">{{ secondaryRcReviewer }}</span> }
            </div>
          </div>

          <div class="form-field">
            <label class="field-label">R&amp;C Supervisor</label>
            <div class="chips-input field-input--readonly">
              @if (form.rcSupervisor) { <span class="chip chip--readonly">{{ form.rcSupervisor }}</span> }
              @if (secondaryRcSupervisor) { <span class="chip chip--readonly">{{ secondaryRcSupervisor }}</span> }
            </div>
          </div>

          <div class="form-field">
            <label class="field-label">R&amp;C Manager</label>
            <div class="chips-input field-input--readonly">
              @if (form.rcManager) { <span class="chip chip--readonly">{{ form.rcManager }}</span> }
              @if (secondaryRcManager) { <span class="chip chip--readonly">{{ secondaryRcManager }}</span> }
            </div>
          </div>

          <div class="form-field" data-field="identificationDate">
            <label class="field-label">Identification Date <span class="required">*</span></label>
            <div class="input-with-icon">
              <input type="text" class="field-input date-text" [value]="identificationDateDisplay"
                placeholder="DD-MMM-YYYY" readonly (click)="openIdentificationDatePicker(idDate)" />
              <input #idDate type="date" class="date-native-hidden"
                [(ngModel)]="form.identificationDate"
                (ngModelChange)="validateField('identificationDate')" />
              <button type="button" class="input-icon-btn" aria-label="Pick date"
                (click)="openIdentificationDatePicker(idDate)">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
              </button>
            </div>
            @if (formErrors['identificationDate']) { <span class="field-error">{{ formErrors['identificationDate'] }}</span> }
          </div>

          <div class="form-field">
            <label class="field-label">Subscribers/Notify</label>
            <div (keydown.enter)="closeSubscriberDropdown(); addSubscriber(subscriberPickerValue)">
              <app-people-picker
                #subscriberPickerRef
                [(ngModel)]="subscriberPickerValue"
                placeholder="Subscribers/Notify"
                (ngModelChange)="subscriberError = ''"
                (personSelected)="onSubscriberPersonSelected($event)">
              </app-people-picker>
            </div>
            @if (form.subscribers.length) {
            <div class="subscriber-chips">
              @for (sub of form.subscribers; track sub) {
              <span class="chip">
                {{ sub.includes('@') ? sub : sub + '@accenture.com' }}
                <span class="chip-remove" (click)="removeSubscriber(sub)">×</span>
              </span>
              }
            </div>
            }
            @if (subscriberError) {
              <span class="field-error">{{ subscriberError }}</span>
            }
          </div>

          <div class="form-field">
            <label class="field-label">Upload File</label>
            <label class="attach-link">
              <input #fileInput type="file" class="attach-file-input" multiple
                accept=".pdf,.msg,.xls,.xlsx,.doc,.docx,.txt,.ppt,.pptx,.jpg,.jpeg,.png,.zip"
                (change)="onFilesSelected($event)" />
              <span class="attach-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48"
                    stroke="#A100FF" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"
                    transform="rotate(-45 12 12)" />
                </svg>
              </span>
              <span>Attach Document</span>
            </label>
            @for (doc of existingIssueDocuments; track doc.StorageFilePath) {
              <div class="file-selected file-existing">
                <a class="file-download-link" (click)="downloadExistingDoc(doc)" title="Download {{ doc.FileName }}">
                  {{ doc.FileName }}
                </a>
                <i class="fa fa-trash delete-icon" (click)="removeExistingDoc(doc)" title="Remove file"></i>
              </div>
            }
            @for (file of attachedFiles; track file.name; let i = $index) {
              <div class="file-selected file-existing">
                <a class="file-download-link" (click)="downloadAttachedFile(file)" title="Download {{ file.name }}">{{ file.name }}</a>
                <i class="fa fa-trash delete-icon" (click)="removeAttachedFile(i)" title="Remove file"></i>
              </div>
            }
            @if (uploadError) {
              <span class="field-error">{{ uploadError }}</span>
            }
          </div>

          <div class="form-field" data-field="rcCommentsForIssue">
            <label class="field-label">
              {{ isGoLive ? 'R&C Comments' : 'R&C Comments for Issue' }}
              <span class="required">*</span>
            </label>
            <textarea class="field-textarea" rows="6"
              [placeholder]="isGoLive ? 'Enter R&C Comments' : 'Enter R&C Comments for Issue'"
              [(ngModel)]="form.rcCommentsForIssue"
              (ngModelChange)="validateRcCommentsForIssue()"></textarea>
            @if (formErrors['rcCommentsForIssue']) { <span class="field-error">{{ formErrors['rcCommentsForIssue'] }}</span> }
          </div>

          <div class="form-field" data-field="actionRequiredBy">
            <label class="field-label">Action Required By <span class="required">*</span></label>
            <div class="select-wrapper">
              <div class="custom-select" tabindex="0"
                (click)="actionRequiredByDropdownOpen = !actionRequiredByDropdownOpen"
                (blur)="actionRequiredByDropdownOpen = false">
                <span [class.multiselect-placeholder]="!form.actionRequiredBy">
                  {{ form.actionRequiredBy || 'Select' }}
                </span>
              </div>
              <span class="select-chevron">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
              @if (actionRequiredByDropdownOpen) {
              <ul class="multiselect-dropdown">
                @for (opt of actionRequiredByOptions; track opt) {
                <li class="multiselect-option" (mousedown)="form.actionRequiredBy = opt; actionRequiredByDropdownOpen = false; validateField('actionRequiredBy')">{{ opt }}</li>
                }
              </ul>
              }
            </div>
            @if (formErrors['actionRequiredBy']) { <span class="field-error">{{ formErrors['actionRequiredBy'] }}</span> }
          </div>

          <div class="form-field" data-field="issueRating">
            <label class="field-label">Issue Rating <span class="required">*</span></label>
            <div class="select-wrapper">
              <div class="custom-select" tabindex="0" #issueRatingTrigger
                (click)="toggleIssueRatingDropdown(issueRatingTrigger)"
                (blur)="issueRatingDropdownOpen = false">
                <span [class.multiselect-placeholder]="!form.issueRating">
                  {{ form.issueRating || 'Select' }}
                </span>
              </div>
              <span class="select-chevron">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
              @if (issueRatingDropdownOpen) {
              <ul class="multiselect-dropdown">
                @for (opt of issueRatingOptions; track opt) {
                <li class="multiselect-option" (mousedown)="form.issueRating = opt; issueRatingDropdownOpen = false; onIssueRatingChange()">{{ opt }}</li>
                }
              </ul>
              }
            </div>
            @if (formErrors['issueRating']) { <span class="field-error">{{ formErrors['issueRating'] }}</span> }
            @if (form.issueRating === 'Blue') {
              <span class="field-error" style="white-space: nowrap;">AP status will be set automatically to Blue-Not Tracked</span>
            }
          </div>

          <div class="form-field">
            <label class="field-label">Legacy Issue Number (AuditBoard Issue ID)</label>
            <input type="text" class="field-input" placeholder="Enter Legacy Issue Number"
              [(ngModel)]="form.legacyIssueNumber" />
          </div>
        </div>

        <!-- ───────── Right column ───────── -->
        <div class="form-col">
          <div class="form-field">
            <label class="field-label">Issue Status</label>
            <input type="text" class="field-input field-input--readonly" [value]="form.issueStatus" readonly />
          </div>

          <div class="form-field" data-field="reviewObjective">
            <label class="field-label">Review Objective <span class="required">*</span></label>
            <textarea class="field-textarea" rows="3" placeholder="Enter Review Objective" [(ngModel)]="form.reviewObjective" (ngModelChange)="validateField('reviewObjective')"></textarea>
            @if (formErrors['reviewObjective']) { <span class="field-error">{{ formErrors['reviewObjective'] }}</span> }
          </div>

          <div class="form-field" data-field="recommendation">
            <label class="field-label">Recommendation <span class="required">*</span></label>
            <textarea class="field-textarea" rows="4" placeholder="Enter Recommendation" [(ngModel)]="form.recommendation" (ngModelChange)="validateField('recommendation')"></textarea>
            @if (formErrors['recommendation']) { <span class="field-error">{{ formErrors['recommendation'] }}</span> }
          </div>

          <div class="form-field" data-field="locationsImpacted">
            <label class="field-label">Location Reviewed and Impacted? <span class="required">*</span></label>
            <div class="select-wrapper">
              <div class="chips-input" (click)="locationDropdownOpen = !locationDropdownOpen; locationDropdownOpen && locationSearch.focus()">
                @for (loc of form.locationsImpacted; track loc) {
                <span class="chip">
                  {{ loc }}
                  <span class="chip-remove" (click)="$event.stopPropagation(); removeLocationWithValidation(loc)">×</span>
                </span>
                }
                <input #locationSearch type="text" class="multiselect-search"
                  [(ngModel)]="locationSearchTerm"
                  [placeholder]="form.locationsImpacted.length ? '' : 'Select'"
                  (click)="$event.stopPropagation()"
                  (focus)="locationDropdownOpen = true"
                  (input)="locationDropdownOpen = true"
                  (blur)="closeLocationDropdown()" />
              </div>
              <span class="select-chevron">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
              @if (locationDropdownOpen && filteredLocationOptions.length) {
              <ul class="multiselect-dropdown">
                @for (opt of filteredLocationOptions; track opt) {
                <li class="multiselect-option" (mousedown)="selectLocation(opt)">{{ opt }}</li>
                }
              </ul>
              }
            </div>
            @if (formErrors['locationsImpacted']) { <span class="field-error">{{ formErrors['locationsImpacted'] }}</span> }
          </div>

          <div class="form-field" data-field="broadCategory">
            <label class="field-label">Broad Issue Category (L1) <span class="required">*</span></label>
            <div class="select-wrapper">
              <div class="custom-select" tabindex="0"
                (click)="broadCategoryDropdownOpen = !broadCategoryDropdownOpen"
                (blur)="broadCategoryDropdownOpen = false">
                <span [class.multiselect-placeholder]="!form.broadCategory">
                  {{ form.broadCategory || 'Select' }}
                </span>
                <span class="select-chevron">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2.5">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </span>
              </div>
              @if (broadCategoryDropdownOpen) {
              <ul class="multiselect-dropdown multiselect-dropdown--wrap">
                @for (opt of broadCategoryOptions; track opt) {
                <li class="multiselect-option" (mousedown)="form.broadCategory = opt; broadCategoryDropdownOpen = false; onBroadCategoryChange()">{{ opt }}</li>
                }
              </ul>
              }
            </div>
            @if (formErrors['broadCategory']) { <span class="field-error">{{ formErrors['broadCategory'] }}</span> }
          </div>

          <div class="form-field" data-field="detailedCategory">
            <label class="field-label">Detailed Issue Category (L2) <span class="required">*</span></label>
            <div class="select-wrapper">
              <div class="custom-select" tabindex="0"
                [class.custom-select--disabled]="!form.broadCategory"
                (click)="form.broadCategory && (detailedCategoryDropdownOpen = !detailedCategoryDropdownOpen)"
                (blur)="detailedCategoryDropdownOpen = false">
                <span [class.multiselect-placeholder]="!form.detailedCategory">
                  {{ form.detailedCategory || 'Select' }}
                </span>
                <span class="select-chevron">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2.5">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </span>
              </div>
              @if (detailedCategoryDropdownOpen) {
              <ul class="multiselect-dropdown multiselect-dropdown--wrap">
                @for (opt of detailedCategoryOptions; track opt) {
                <li class="multiselect-option" (mousedown)="form.detailedCategory = opt; detailedCategoryDropdownOpen = false; onDetailedCategoryChange()">{{ opt }}</li>
                }
              </ul>
              }
            </div>
            @if (formErrors['detailedCategory']) { <span class="field-error">{{ formErrors['detailedCategory'] }}</span> }
          </div>

          <div class="form-field" data-field="riskStatement">
            <label class="field-label">Risk Statement (L3) <span class="required">*</span></label>
            <div class="select-wrapper">
              <div class="custom-select" tabindex="0"
                [class.custom-select--disabled]="!form.detailedCategory"
                (click)="form.detailedCategory && (riskStatementDropdownOpen = !riskStatementDropdownOpen)"
                (blur)="riskStatementDropdownOpen = false">
                <span [class.multiselect-placeholder]="!form.riskStatement">
                  {{ form.riskStatement || 'Select' }}
                </span>
              </div>
              <span class="select-chevron">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
              @if (riskStatementDropdownOpen) {
              <ul class="multiselect-dropdown multiselect-dropdown--wrap">
                @for (opt of riskStatementOptions; track opt) {
                <li class="multiselect-option" (mousedown)="form.riskStatement = opt; riskStatementDropdownOpen = false; validateField('riskStatement')">{{ opt }}</li>
                }
              </ul>
              }
            </div>
            @if (formErrors['riskStatement']) { <span class="field-error">{{ formErrors['riskStatement'] }}</span> }
          </div>

          <div class="form-field" data-field="repLetterConflict">
            <label class="field-label">{{ isGoLive ? 'Pre Go-Live/Mob RepLetter Conflict' : 'RepLetter Conflict' }} <span class="required">*</span></label>
            <div class="select-wrapper">
              <div class="custom-select" tabindex="0"
                (click)="repLetterConflictDropdownOpen = !repLetterConflictDropdownOpen"
                (blur)="repLetterConflictDropdownOpen = false">
                <span [class.multiselect-placeholder]="!form.repLetterConflict">
                  {{ form.repLetterConflict || 'Select' }}
                </span>
              </div>
              <span class="select-chevron">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
              @if (repLetterConflictDropdownOpen) {
              <ul class="multiselect-dropdown">
                @for (opt of repLetterConflictOptions; track opt) {
                <li class="multiselect-option" (mousedown)="form.repLetterConflict = opt; repLetterConflictDropdownOpen = false; onRepLetterConflictChange()">{{ opt }}</li>
                }
              </ul>
              }
            </div>
            @if (formErrors['repLetterConflict']) { <span class="field-error">{{ formErrors['repLetterConflict'] }}</span> }
          </div>

          <div class="form-field" data-field="repLetterQuestionsWithConflict">
            <label class="field-label" [class.field-label--nowrap]="isGoLive">{{ isGoLive ? 'Pre Go-Live/Mob RepLetter Questions with Conflict' : 'RepLetter Questions with Conflict' }} <span class="required">*</span></label>
            <div class="select-wrapper"
              [class.field-input--disabled]="form.repLetterConflict !== 'Yes'">
              <div class="chips-input"
                [class.field-input--disabled]="form.repLetterConflict !== 'Yes'"
                (click)="form.repLetterConflict === 'Yes' && (repLetterQuestionsDropdownOpen = !repLetterQuestionsDropdownOpen)">
                <input type="text" class="multiselect-search"
                  [(ngModel)]="repLetterQuestionsSearch"
                  placeholder="Question"
                  [disabled]="form.repLetterConflict !== 'Yes'"
                  (click)="$event.stopPropagation()"
                  (focus)="form.repLetterConflict === 'Yes' && (repLetterQuestionsDropdownOpen = true)"
                  (input)="form.repLetterConflict === 'Yes' && (repLetterQuestionsDropdownOpen = true)"
                  (blur)="closeRepLetterQuestionsDropdown()" />
              </div>
              @if (form.repLetterConflict === 'Yes') {
              <span class="select-search-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2.5"
                  stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="10" cy="10" r="7" />
                  <line x1="22" y1="22" x2="15.5" y2="15.5" />
                </svg>
              </span>
              }
              @if (repLetterQuestionsDropdownOpen && form.repLetterConflict === 'Yes') {
              <ul class="multiselect-dropdown">
                @for (opt of filteredRepLetterQuestions; track opt) {
                <li class="multiselect-option" (mousedown)="addRepLetterQuestion(opt)">{{ opt }}</li>
                }
              </ul>
              }
            </div>
            @if (form.repLetterQuestionsWithConflict.length) {
            <div class="subscriber-chips">
              @for (q of form.repLetterQuestionsWithConflict; track q) {
              @if (q !== 'N/A') {
              <span class="chip" [class.chip--readonly]="form.repLetterConflict !== 'Yes'">
                {{ q }}
                @if (form.repLetterConflict === 'Yes') {
                <span class="chip-remove" (click)="removeRepLetterQuestionWithValidation(q)">×</span>
                }
              </span>
              }
              }
            </div>
            }
            @if (formErrors['repLetterQuestionsWithConflict']) { <span class="field-error">{{ formErrors['repLetterQuestionsWithConflict'] }}</span> }
          </div>

          <div class="form-field" data-field="financialYear">
            <label class="field-label">Financial Year <span class="required">*</span></label>
            <div class="select-wrapper">
              <select class="field-select"
                [class.field-input--disabled]="form.repLetterConflict !== 'Yes'"
                [(ngModel)]="form.financialYear"
                [disabled]="form.repLetterConflict !== 'Yes'">
                @for (opt of financialYearOptions; track opt) {
                <option [value]="opt">{{ opt }}</option>
                }
              </select>
              <span class="select-chevron">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
            </div>
            @if (formErrors['financialYear']) { <span class="field-error">{{ formErrors['financialYear'] }}</span> }
          </div>

          <div class="form-field" data-field="quarter">
            <label class="field-label">Quarter <span class="required">*</span></label>
            <div class="select-wrapper">
              <select class="field-select"
                [class.field-input--disabled]="form.repLetterConflict !== 'Yes'"
                [(ngModel)]="form.quarter"
                [disabled]="form.repLetterConflict !== 'Yes'">
                @for (opt of quarterOptions; track opt) {
                <option [value]="opt">{{ opt }}</option>
                }
              </select>
              <span class="select-chevron">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
            </div>
            @if (formErrors['quarter']) { <span class="field-error">{{ formErrors['quarter'] }}</span> }
          </div>

          <div class="form-field" data-field="serviceLines">
            <label class="field-label">Accenture Operation Service Line <span class="required">*</span></label>
            <div class="select-wrapper">
              <div class="chips-input" tabindex="0"
                (click)="serviceLineDropdownOpen = !serviceLineDropdownOpen"
                (blur)="closeServiceLineDropdown()">
                @for (sl of form.serviceLines; track sl) {
                <span class="chip">
                  {{ sl }}
                  <span class="chip-remove" (click)="$event.stopPropagation(); removeServiceLineWithValidation(sl)">×</span>
                </span>
                }
                @if (!form.serviceLines.length) {
                <span class="multiselect-placeholder">Select</span>
                }
              </div>
              <span class="select-chevron">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
              @if (serviceLineDropdownOpen && availableServiceLines.length) {
              <ul class="multiselect-dropdown">
                @for (opt of availableServiceLines; track opt) {
                <li class="multiselect-option" (mousedown)="selectServiceLine(opt)">{{ opt }}</li>
                }
              </ul>
              }
            </div>
            @if (formErrors['serviceLines']) { <span class="field-error">{{ formErrors['serviceLines'] }}</span> }
          </div>

          <div class="form-field">
            <label class="field-label">Issue Close Due Date</label>
            <input type="text" class="field-input field-input--readonly" [value]="computedIssueCloseDueDate" readonly />
          </div>

          <div class="form-field" [attr.data-field]="isGoLive ? 'reportStatus' : null">
            <label class="field-label">Report Status @if (isGoLive) { <span class="required">*</span> }</label>
            <div class="select-wrapper">
              <div class="custom-select" tabindex="0" #reportStatusTrigger
                (click)="toggleReportStatusDropdown(reportStatusTrigger)"
                (blur)="closeReportStatusDropdown()">
                <span [class.multiselect-placeholder]="!form.reportStatus">
                  {{ form.reportStatus || 'Select' }}
                </span>
              </div>
              <span class="select-chevron">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
              @if (reportStatusDropdownOpen) {
              <ul class="multiselect-dropdown">
                @for (opt of reportStatusOptions; track opt) {
                <li class="multiselect-option" (mousedown)="selectReportStatus(opt)">{{ opt }}</li>
                }
              </ul>
              }
            </div>
            @if (isGoLive && formErrors['reportStatus']) { <span class="field-error">{{ formErrors['reportStatus'] }}</span> }
          </div>

          @if (isGoLive) {
          <div class="form-field" data-field="issueFromGoLive">
            <label class="field-label">Is this Issue from Go-Live? <span class="required">*</span></label>
            <div class="select-wrapper">
              <div class="custom-select" tabindex="0"
                (click)="issueFromGoLiveDropdownOpen = !issueFromGoLiveDropdownOpen"
                (blur)="issueFromGoLiveDropdownOpen = false">
                <span [class.multiselect-placeholder]="!form.issueFromGoLive">
                  {{ form.issueFromGoLive || 'Select' }}
                </span>
              </div>
              <span class="select-chevron">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
              @if (issueFromGoLiveDropdownOpen) {
              <ul class="multiselect-dropdown">
                @for (opt of issueFromGoLiveOptions; track opt) {
                <li class="multiselect-option" (mousedown)="selectIssueFromGoLive(opt)">{{ opt }}</li>
                }
              </ul>
              }
            </div>
            @if (formErrors['issueFromGoLive']) { <span class="field-error">{{ formErrors['issueFromGoLive'] }}</span> }
          </div>
          }
        </div>
      </div>
    </div>

    <!-- Step 1 Footer -->
    <div class="modal-footer">
      <button type="button" class="btn-pill btn-pill--outline" [disabled]="!isFormDirty" (click)="onCancel()">Cancel</button>
      <button type="button" class="btn-pill btn-pill--filled" [disabled]="!isFormDirty" (click)="onSaveDraft()">Save as Draft</button>
      <button type="button" class="btn-pill btn-pill--filled" [disabled]="!isFormDirty" (click)="goToStep2()">Next, Add Action Plan</button>
    </div>
    }

    @if (currentStep === 2) {
    <!-- Step 2 Body -->
    <div class="modal-body">

      <!-- Issue summary row -->
      <div class="ap-summary-grid">
        <div class="form-field">
          <label class="field-label">Issue ID</label>
          <input type="text" class="field-input field-input--readonly" [value]="form.issueId" readonly />
        </div>
        <div class="form-field">
          <label class="field-label">Issue Title</label>
          <input type="text" class="field-input field-input--readonly" [value]="form.issueTitle" readonly />
        </div>
      </div>

      <!-- Action buttons row -->
      <div class="ap-action-buttons-row">
        <button type="button" class="btn-pill"
          [class.btn-pill--outline-primary]="showCreateActionPlan"
          [class.btn-pill--outline-muted]="!showCreateActionPlan"
          [disabled]="!showCreateActionPlan"
          (click)="backToActionPlanList()">Add Existing Action Plan</button>
        <button type="button" class="btn-pill"
          [class.btn-pill--filled]="!showCreateActionPlan"
          [class.btn-pill--outline-muted]="showCreateActionPlan"
          [disabled]="showCreateActionPlan"
          (click)="onCreateNewActionPlan()">
          <span class="btn-plus">+</span> Create New Action Plan
        </button>
      </div>

      @if (!showCreateActionPlan) {
      <!-- Search -->
      <div class="ap-search-row">
        <div class="ap-search-wrapper">
          <input type="text" class="field-input ap-search-input" placeholder="Search Action Plan"
            [(ngModel)]="actionPlanSearch" />
          <button type="button" class="ap-search-icon-btn" aria-label="Search">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Table -->
      <div class="ap-table-wrapper">
        <table class="ap-table">
          <thead>
            <tr>
              <th class="col-ap-id">Action Plan ID</th>
              <th class="col-ap-desc">Action Plan Description</th>
              <th class="col-owner">Owner</th>
              <th class="col-target">Target Date</th>
              <th class="col-status">AP Status</th>
              <th class="col-linked">Linked Issue</th>
              <th class="col-action">Action</th>
            </tr>
          </thead>
          <tbody>
            @for (row of filteredActionPlanRows; track row.id) {
            <tr>
              <td><span class="ap-id ap-id--link" (click)="openActionPlanInNewTab(row.id)">{{ row.id }}</span></td>
              <td class="ap-td-ellipsis" [title]="row.description">{{ row.description }}</td>
              <td class="ap-td-ellipsis" [title]="row.owner">{{ row.owner }}</td>
              <td>{{ row.targetDate }}</td>
              <td class="ap-td-ellipsis" [title]="row.status">{{ row.status }}</td>
              <td class="col-linked ap-td-linked">
                @for (id of parseLinkedIssues(row.linkedIssues); track id; let i = $index) {
                  @if (i < 2) {
                    <span class="linked-id-chip" [title]="getIssueStatusTooltip(id)">{{ id }}</span>
                  }
                }
                @if (parseLinkedIssues(row.linkedIssues).length > 2) {
                  <span class="linked-id-more" [title]="linkedIssuesTooltip(row.linkedIssues)">...</span>
                }
              </td>
              <td class="col-action-cell">
                <div class="ap-action-inner">
                  <input type="checkbox" class="ap-row-checkbox" [(ngModel)]="row.linked" (ngModelChange)="onApLinkToggle(row, $event)" [id]="'ap-link-' + row.id" />
                  <label class="ap-link-label" [for]="'ap-link-' + row.id">Link</label>
                </div>
              </td>
            </tr>
            } @empty {
            <tr>
              <td colspan="7" class="ap-empty-cell">
                @if (actionPlanSearch.trim()) {
                  No records found.
                } @else {
                  No action plans have been created for this review yet.
                }
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
      } @else {
      <!-- "Add Another Action Plan" link — shown once at least one AP form exists -->
      <div class="ap-add-another-row">
        <button type="button" class="ap-add-another-btn" (click)="onAddAnotherActionPlan()">
          + Add Another Action Plan
        </button>
      </div>

      <!-- One accordion per new action plan -->
      @for (ap of newActionPlans; track ap; let i = $index) {
      <div class="ap-accordion">
        <!-- Accordion Header -->
        <div class="ap-accordion-header" [class.ap-accordion-header--expanded]="apExpandedIndex === i"
             (click)="toggleApAccordion(i)">
          <span>Action Plan ID: {{ ap.id }}</span>
          <div class="ap-accordion-header-actions">
            @if (newActionPlans.length > 1) {
            <button type="button" class="ap-delete-btn"
              (click)="$event.stopPropagation(); removeNewActionPlan(i)" title="Delete Action Plan">
              <i class="fa fa-trash"></i>
            </button>
            }
            <svg class="ap-chevron" [class.ap-chevron--open]="apExpandedIndex === i"
              width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </div>
        </div>

        <!-- Accordion Body — visible only when this AP is expanded -->
        @if (apExpandedIndex === i) {
        <div class="form-grid">
          <!-- Left column -->
          <div class="form-col">
            <div class="form-field">
              <label class="field-label">Action Plan ID</label>
              <input type="text" class="field-input field-input--readonly" [value]="ap.id" readonly />
            </div>

            <div class="form-field" [attr.data-ap-field]="'description-' + i">
              <label class="field-label">Action Plan Description <span class="required">*</span></label>
              <textarea class="field-textarea" rows="3" placeholder="Enter Action Plan Description"
                [(ngModel)]="ap.description" (ngModelChange)="validateActionPlanField(i, 'description')"></textarea>
              @if (apErrorsByIndex[i]?.['description']) {
                <span class="field-error">{{ apErrorsByIndex[i]['description'] }}</span>
              }
            </div>

            <div class="form-field" [attr.data-ap-field]="'closedDate-' + i">
              <label class="field-label">Closed date for the action plan @if (isClosedDateRequired(ap)) { <span class="required">*</span> }</label>
              <div class="input-with-icon">
                <input type="text" class="field-input date-text" [value]="formatDate(ap.closedDate)"
                  placeholder="DD-MMM-YYYY" readonly (click)="openIdentificationDatePicker(apClosedDate)" />
                <input #apClosedDate type="date" class="date-native-hidden" [(ngModel)]="ap.closedDate"
                  (ngModelChange)="validateActionPlanField(i, 'closedDate')" />
                <button type="button" class="input-icon-btn" aria-label="Pick date"
                  (click)="openIdentificationDatePicker(apClosedDate)">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                    <line x1="8" y1="2" x2="8" y2="6" />
                    <line x1="3" y1="10" x2="21" y2="10" />
                  </svg>
                </button>
              </div>
              @if (apErrorsByIndex[i]?.['closedDate']) {
                <span class="field-error">{{ apErrorsByIndex[i]['closedDate'] }}</span>
              }
            </div>

            <div class="form-field">
              <label class="field-label">Internal Dependency</label>
              <div class="select-wrapper">
                <input type="text" class="field-input" placeholder="Search"
                  [(ngModel)]="internalDependencySearch"
                  (focus)="internalDependencyDropdownOpen = true"
                  (input)="internalDependencyDropdownOpen = true"
                  (blur)="closeInternalDependencyDropdown()" />
                <span class="select-search-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2">
                    <circle cx="11" cy="11" r="8" />
                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                  </svg>
                </span>
                @if (internalDependencyDropdownOpen && getFilteredInternalDependencyOptions(i).length) {
                <ul class="multiselect-dropdown">
                  @for (opt of getFilteredInternalDependencyOptions(i); track opt) {
                  <li class="multiselect-option" (mousedown)="selectInternalDependency(i, opt)">{{ opt }}</li>
                  }
                </ul>
                }
              </div>
              @if (ap.internalDependencies.length) {
              <div class="subscriber-chips">
                @for (dep of ap.internalDependencies; track dep) {
                <span class="chip">{{ dep }}<span class="chip-remove" (click)="removeInternalDependency(i, dep)">×</span></span>
                }
              </div>
              }
            </div>

            <div class="form-field" [attr.data-ap-field]="'targetDate-' + i">
              <label class="field-label">Target date for action plan/remediation action @if (ap.status && (ap.status.toLowerCase() === 'open' || ap.status.toLowerCase() === 'open-ageing & static')) {<span class="required">*</span>}</label>
              <div class="input-with-icon">
                <input type="text" class="field-input date-text" [value]="formatDate(ap.targetDate)"
                  placeholder="DD-MMM-YYYY" readonly (click)="openIdentificationDatePicker(apTargetDate)" />
                <input #apTargetDate type="date" class="date-native-hidden" [(ngModel)]="ap.targetDate"
                  (ngModelChange)="validateActionPlanField(i, 'targetDate')" />
                <button type="button" class="input-icon-btn" aria-label="Pick date"
                  (click)="openIdentificationDatePicker(apTargetDate)">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                    <line x1="8" y1="2" x2="8" y2="6" />
                    <line x1="3" y1="10" x2="21" y2="10" />
                  </svg>
                </button>
              </div>
              @if (apErrorsByIndex[i]?.['targetDate']) {
                <span class="field-error">{{ apErrorsByIndex[i]['targetDate'] }}</span>
              }
            </div>

            <div class="form-field" [attr.data-ap-field]="'owners-' + i">
              <label class="field-label">Owner for action plan/remediation action <span class="required">*</span></label>
              <div (keydown.enter)="closeOwnerDropdown(i); addActionPlanOwner(i)">
                <app-people-picker
                  #ownerPickerRef
                  [(ngModel)]="apOwnerPickerValues[i]"
                  placeholder="Search"
                  (ngModelChange)="apErrorsByIndex[i] && (apErrorsByIndex[i]['owners'] = '')"
                  (personSelected)="onOwnerPersonSelected(i, $event)">
                </app-people-picker>
              </div>
              @if (ap.owners.length) {
              <div class="subscriber-chips">
                @for (owner of ap.owners; track owner) {
                <span class="chip">{{ owner }}<span class="chip-remove" (click)="removeActionPlanOwner(i, owner)">×</span></span>
                }
              </div>
              }
              @if (apErrorsByIndex[i]?.['owners']) {
                <span class="field-error">{{ apErrorsByIndex[i]['owners'] }}</span>
              }
            </div>
          </div>

          <!-- Right column -->
          <div class="form-col">
            <div class="form-field" [attr.data-ap-field]="'status-' + i">
              @if (form.issueRating === 'Blue') {
              <div class="ap-blue-status-info">
                For changing status to Blue-Not Tracked the issue rating must be set to Blue
              </div>
              }
              <label class="field-label">Action Plan Status <span class="required">*</span></label>
              @if (form.issueRating === 'Blue') {
              <!-- Blue rating: readonly, pre-populated with Closed-Blue Not Tracked -->
              <input type="text" class="field-input field-input--readonly" [value]="ap.status" readonly />
              } @else {
              <div class="select-wrapper">
                <select class="field-select" [class.field-select--error]="!!apErrorsByIndex[i]?.['status']"
                  [(ngModel)]="ap.status"
                  (ngModelChange)="apErrorsByIndex[i] && (apErrorsByIndex[i]['status'] = ''); apErrorsByIndex[i]?.['targetDate'] && validateActionPlanField(i, 'targetDate'); validateClosedDateOnStatusChange(i)">
                  <option value="" disabled>Select</option>
                  @for (opt of actionPlanStatusOptions; track opt) {
                  <option [value]="opt">{{ opt }}</option>
                  }
                </select>
                <span class="select-chevron">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2.5">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </span>
              </div>
              }
              @if (apErrorsByIndex[i]?.['status']) {
                <span class="field-error">{{ apErrorsByIndex[i]['status'] }}</span>
              }
            </div>

            <div class="form-field">
              <label class="field-label">Revised target date</label>
              <div class="input-with-icon">
                <input type="text" class="field-input date-text" [value]="formatDate(ap.revisedTargetDate)"
                  placeholder="DD-MMM-YYYY" readonly (click)="openIdentificationDatePicker(apRevisedDate)" />
                <input #apRevisedDate type="date" class="date-native-hidden" [(ngModel)]="ap.revisedTargetDate" />
                <button type="button" class="input-icon-btn" aria-label="Pick date"
                  (click)="openIdentificationDatePicker(apRevisedDate)">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                    <line x1="8" y1="2" x2="8" y2="6" />
                    <line x1="3" y1="10" x2="21" y2="10" />
                  </svg>
                </button>
              </div>
            </div>

            <div class="form-field" [attr.data-ap-field]="'rcComments-' + i">
              <label class="field-label">R&amp;C Comments for Action Plan<span class="required">*</span></label>
              <textarea class="field-textarea" rows="3" placeholder="Enter R&C Comments"
                [(ngModel)]="ap.rcComments" (ngModelChange)="validateActionPlanField(i, 'rcComments')"></textarea>
                @if (apErrorsByIndex[i]?.['rcComments']) {
                <span class="field-error">{{ apErrorsByIndex[i]['rcComments'] }}</span>
              }
            </div>

            <div class="form-field">
              <label class="field-label">Upload File</label>
              <label class="attach-link">
                <input type="file" class="attach-file-input" multiple
                  accept=".pdf,.msg,.xls,.xlsx,.doc,.docx,.txt,.ppt,.pptx,.jpg,.jpeg,.png,.zip"
                  (change)="onActionPlanFilesSelected(i, $event)" />
                <span class="attach-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48"
                      stroke="#A100FF" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"
                      transform="rotate(-45 12 12)" />
                  </svg>
                </span>
                <span>Attach Document</span>
              </label>
              @for (file of (apFilesByIndex[i] ?? []); track file.name; let fi = $index) {
                <div class="file-selected">
                  <a class="file-download-link" (click)="downloadAttachedFile(file)" title="Download {{ file.name }}">{{ file.name }}</a>
                  <i class="fa fa-trash delete-icon" (click)="removeActionPlanFile(i, fi)" title="Remove file"></i>
                </div>
              }
              @if (apUploadErrorsByIndex[i]) {
                <span class="field-error">{{ apUploadErrorsByIndex[i] }}</span>
              }
            </div>

            <div class="form-field">
              <label class="field-label">Client Dependency</label>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" [name]="'clientDependency-' + i" value="Yes" [(ngModel)]="ap.clientDependency" />
                  <span>Yes</span>
                </label>
                <label class="radio-option">
                  <input type="radio" [name]="'clientDependency-' + i" value="No" [(ngModel)]="ap.clientDependency" />
                  <span>No</span>
                </label>
              </div>
            </div>

            <div class="form-field">
              <label class="field-label">
                {{ isGoLive ? 'Red-client related Observation-Client informed date' : 'Red client Observation Client informed date' }}
                @if (isClientInformedDateEnabled(ap)) { <span class="required">*</span> }
              </label>
              <div class="input-with-icon">
                <input type="text" class="field-input date-text"
                  [class.field-input--disabled]="isGoLive && !isClientInformedDateEnabled(ap)"
                  [value]="formatDate(ap.redClientInformedDate)"
                  placeholder="DD-MMM-YYYY" readonly
                  (click)="openIdentificationDatePicker(apRedClientDate)" />
                <input #apRedClientDate type="date" class="date-native-hidden"
                  [(ngModel)]="ap.redClientInformedDate"
                  [disabled]="isGoLive && !isClientInformedDateEnabled(ap)" />
                <button type="button" class="input-icon-btn" aria-label="Pick date"
                  [disabled]="isGoLive && !isClientInformedDateEnabled(ap)"
                  (click)="openIdentificationDatePicker(apRedClientDate)">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                    <line x1="8" y1="2" x2="8" y2="6" />
                    <line x1="3" y1="10" x2="21" y2="10" />
                  </svg>
                </button>
              </div>
              @if (apErrorsByIndex[i]?.['redClientInformedDate']) {
                <span class="field-error">{{ apErrorsByIndex[i]['redClientInformedDate'] }}</span>
              }
            </div>

            <div class="form-field">
              <label class="field-label">Target Date to Inform Red Client Observation Client Informed Date</label>
              <div class="input-with-icon">
                <input type="text" class="field-input date-text" [value]="formatDate(ap.targetDateToInformRedClient)"
                  placeholder="DD-MMM-YYYY" readonly (click)="openIdentificationDatePicker(apTargetInformDate)" />
                <input #apTargetInformDate type="date" class="date-native-hidden" [(ngModel)]="ap.targetDateToInformRedClient" />
                <button type="button" class="input-icon-btn" aria-label="Pick date"
                  (click)="openIdentificationDatePicker(apTargetInformDate)">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                    <line x1="8" y1="2" x2="8" y2="6" />
                    <line x1="3" y1="10" x2="21" y2="10" />
                  </svg>
                </button>
              </div>
            </div>

            <div class="form-field">
              <label class="field-label">Legacy AP Number (AuditBoard AP ID)</label>
              <input type="text" class="field-input" placeholder="Enter Legacy AP Number"
                [(ngModel)]="ap.legacyApNumber" />
            </div>
          </div>
        </div>
        }
      </div>
      }
      }
    </div>

    <!-- Step 2 Footer -->
    @if (incompleteApMessage) {
    <div class="field-error" role="alert" style="padding: 0 24px 8px;">{{ incompleteApMessage }}</div>
    }
    <div class="modal-footer">
      <button type="button" class="btn-link" (click)="showCreateActionPlan ? backToActionPlanList() : backToStep1()">Back</button>
      <button type="button" class="btn-pill btn-pill--outline" (click)="onCancel()">Cancel</button>
      <button type="button" class="btn-pill btn-pill--filled" [disabled]="showCreateActionPlan ? !isActionPlanFormDirty : !hasLinkedActionPlan"
        (click)="onSaveDraft()">Save as Draft</button>
      <button type="button" class="btn-pill btn-pill--disabled" [disabled]="(showCreateActionPlan ? !isActionPlanFormDirty : !hasLinkedActionPlan) || incompleteLinkedApIds.length > 0"
        (click)="onSendForApproval()">Send for Approval</button>
    </div>
    }

  </div>
</div>
}